module.exports = __webpack_public_path__ + "img/networkCarTransportLicense.8329ea96.png";